<section class="sec" style="padding-top:20px">
  <div class="wrap">
    <div class="app-cta" appReveal>
      <div>
        <span class="kicker" style="color:#9DB0FF">Companion App</span>
        <h2>Download the ConnectNow Companion App</h2>
        <p>Stay connected and manage customer interactions seamlessly on the go. Complement your ConnectNow platform and transform customer engagement from anywhere.</p>
        <div class="store-btns">
          <a class="store-btn" href="https://apps.apple.com/us/app/connectnow-ai/id1670078798">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 1.5c0 1.3-.5 2.4-1.4 3.3-1 1.1-2.2 1.7-3.4 1.6-.1-1.3.5-2.5 1.4-3.4.9-.9 2.3-1.5 3.4-1.5zM20 17c-.5 1.2-.8 1.7-1.5 2.8-1 1.5-2.4 3.4-4.1 3.4-1.5 0-1.9-1-4-1-2 0-2.5 1-4 1-1.7 0-3-1.7-4-3.2-2.8-4.3-3.1-9.3-1.4-12 1.2-1.9 3.1-3 4.9-3 1.8 0 3 1 4.5 1 1.5 0 2.4-1 4.5-1 1.6 0 3.2.9 4.4 2.3-3.9 2.1-3.2 7.6.7 9.9z"/></svg>
            <span><small>Download on the</small><b>App Store</b></span>
          </a>
          <a class="store-btn" href="https://play.google.com/store/apps/details?id=com.kayool.kayoolshop">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l9-9.7-9-9.7zM15.5 9.2l-2.4-1.4-2.8 3 2.8 3 2.5-1.4c1-.6 1-2.2-.1-2.8zM5.2 1.6l9.4 5.4 2.3 2.4-2.3-2.4L5.2 1.6zm0 20.8l9.4-5.4-2.3-2.4 2.3 2.4-9.4 5.4z"/></svg>
            <span><small>Get it on</small><b>Google Play</b></span>
          </a>
        </div>
      </div>
      <div class="app-mock">
        <div class="phone">
          <span class="notch"></span>
          <div class="screen">
            <div class="pill w1"></div><div class="pill w2"></div><div class="pill w3"></div>
            <div class="bubble">Hi! How can I help you today?</div>
            <div class="bubble me">Track my order #4821</div>
            <div class="bubble">It's out for delivery 🚚</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
